import React from "react";
import { ACTION_TYPES, URLS } from "utils/constants";
import { useNavigate } from "react-router-dom";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import InvoiceForm from "./components/invoice-form";
import InvoicePreview from "./components/invoice-preview";
import { IconArrowLeft, IconDeviceFloppy } from "@tabler/icons-react";
import { useInvoiceCreate } from "contexts/v1/pages/InvoiceCreateContext";

const InvoiceCreatePage = () => {
    const { invoice, createInvoice, updateInvoice } = useInvoiceCreate();

    const navigate = useNavigate();

    return (
        <LayoutDashboard>
            {/* Breadcrumb */}
            <div className="d-flex justify-content-between align-items-center p-3">
                <div className='d-flex justify-content-between align-items-center w-100'>
                    {/* Title Dashboard dengan border-right */}
                    <h2 className="m-0 me-3 fs-2 border-0 pe-3">Invoice Generator</h2>

                    <div className="d-flex">
                        <button className="btn btn-secondary me-2" onClick={() => {
                            navigate(URLS.v1.INVOICES);
                        }}>
                            <IconArrowLeft className="me-2" size={18} /> Back
                        </button>,
                        <button className="btn btn-primary" onClick={() => {
                            if (invoice.mode === ACTION_TYPES.CREATE) {
                                createInvoice();
                            } else {
                                updateInvoice();
                            }
                        }} disabled={invoice.isSubmitting}>
                            <IconDeviceFloppy className="me-2" size={18} /> Save
                        </button>
                    </div>
                </div>
            </div>

            <div className="container-fluid pb-4">
                <div className="row">
                    <div className="col-lg-4">
                        <InvoiceForm />
                    </div>
                    <div className="col-lg-8">
                        <InvoicePreview invoice={invoice} />
                    </div>
                </div>
            </div>
        </LayoutDashboard>
    );
};

export default InvoiceCreatePage;